import * as React from 'react';
import styled from 'styled-components';
import { Container } from '../../layout/Container';
import { DeliveryContainer } from './Container';
import { DeliverySteps } from './DeliverySteps';

const StyledSectionDeliverySteps = styled.section`
  display: none;
  width: 100%;
  padding: 3em 0;
  background: ${({ theme }) => theme.colors.burgyndy_shade};

  .delivery-steps-container {
    max-width: 70rem;
  }

  @media all and (min-width: 1400px) {
    display: block;
  }
`;

export const SectionDeliverySteps: React.FC = () => {
  return (
    <StyledSectionDeliverySteps>
      <DeliveryContainer>
        <DeliverySteps />
      </DeliveryContainer>
    </StyledSectionDeliverySteps>
  );
};
